export enum Module {
  REQUEST = 1,
  PHYSICAL_TRANSPORT = 2,
  INTERMODAL = 3,
  COMPLIANCE = 4,
  ADMIN = 5,
  LOGCHAIN = 6,
  REGULATORY = 7,
  ALERT = 8,
  OUTBOUND_OUTHOUSE_SHIPMENT = 9,
}
